import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const SendEmail24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.81534 4.38844L12 12.6546L21.1847 4.38845C20.8531 4.14428 20.4434 4 20 4H4C3.55662 4 3.14694 4.14428 2.81534 4.38844Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M22 6.34538L13.3379 14.1412C12.5773 14.8258 11.4227 14.8258 10.6621 14.1412L2 6.34536V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6.34538Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
